import { render, staticRenderFns } from "./vip-right.vue?vue&type=template&id=34bf31e2&scoped=true&"
import script from "./vip-right.vue?vue&type=script&lang=js&"
export * from "./vip-right.vue?vue&type=script&lang=js&"
import style0 from "./vip-right.vue?vue&type=style&index=0&id=34bf31e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bf31e2",
  null
  
)

export default component.exports